import UriTemplate from 'uri-templates';
import {halClient} from "../../hal";
import {context} from "../../constants/context";
import {BBModel} from "../../bb_model";
import {BaseModel} from "../base";

class AffiliateModel extends BaseModel {

    constructor(data) {
        super(data);
        this.test = 1;
    }

    /**
     * @description
     * Find a company in according to reference
     *
     * @param {string} ref A reference to find a company based on it
     *
     * @returns {Promise} A promise for the company reference
     */
    getCompanyByRef(ref) {

        const prms = {
            id: this.cookie,
            reference: ref
        };

        const href = `${context.apiUrl}/api/${context.apiVersion}/affiliates/{id}/companies/{reference}`;
        const uri = new UriTemplate(href).fillFromObject(prms || {});

        return new Promise((resolve, reject) => {

            halClient.$get(uri, {}).then((company) => {
                    if (company) {
                        return resolve(new BBModel.Company(company));
                    } else {
                        return reject(`No company for ref ${ref}`);
                    }
                }
                , (err) => {
                    console.log('err ', err);
                    return reject(err);
                });
        });
    }
}

export {
    AffiliateModel
}
